import { Team } from "./Team";

export class UpcomingMatch {
    constructor(
        public challonge_id: string,
        public team1: Team,
        public team2: Team,
        public match_time: string,
        public division: string,
        public stream_url: string,
        public isPlayoff: boolean,
        public roundNumber: number | null,
        public playoffPlayed: boolean,
    ) { }
}